//@ts-nocheck
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'nprogress/nprogress.css'
import Vant from 'vant';
import 'vant/lib/index.css';
import { Toast } from 'vant';
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import AxiosInterceptor from './interceptor/axios-interceptor';
import  'animate.css'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import VConsole from 'vconsole'
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'

// if(process.env.NODE_ENV === 'test'|| process.env.NODE_ENV === 'development'){
//   new VConsole();
// }

createApp(App)
  .use(store)
  .use(router)
  .use(Vant)
  .use(Toast)
  .use(AxiosInterceptor)
  .use(Viewer)
  .use(VXETable)
  .mount('#app')
